const getters = {
  getQueues: (state) => state.queues || [],
  getAccounts: (state) => state.accounts || [],
  isQueuesLoading: (state) => !!state.loading,
  getQueuesError: (state) => state.error,
  
  // Meaning Analysis Duration
  getMeaningAnalysisData: (state) => (widgetId) => {
    return state.meaningAnalysisWidgets?.[widgetId]?.data || null
  },
  isMeaningAnalysisLoading: (state) => (widgetId) => {
    return state.meaningAnalysisWidgets?.[widgetId]?.loading || false
  },
  getMeaningAnalysisError: (state) => (widgetId) => {
    return state.meaningAnalysisWidgets?.[widgetId]?.error || null
  },
  
  // Generic widgets
  getGenericWidgetData: (state) => (widgetId) => {
    return state.genericWidgets?.[widgetId]?.data || null
  },
  isGenericWidgetLoading: (state) => (widgetId) => {
    return state.genericWidgets?.[widgetId]?.loading || false
  },
  getGenericWidgetError: (state) => (widgetId) => {
    return state.genericWidgets?.[widgetId]?.error || null
  },
  
  // Time widgets
  getTimeWidgetData: (state) => (widgetId) => {
    return state.timeWidgets?.[widgetId]?.data || null
  },
  isTimeWidgetLoading: (state) => (widgetId) => {
    return state.timeWidgets?.[widgetId]?.loading || false
  },
  getTimeWidgetError: (state) => (widgetId) => {
    return state.timeWidgets?.[widgetId]?.error || null
  }
}

export default getters
